import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  register,
  login,
  forgetpwd,
  save_ip,
  resendOtp,
  registerVerify,
  googleLogin,
  googleCompleteRegistration,
  switchAccount,
} from "../../Apis";

export const RegisterUser = createAsyncThunk(
  "register",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await register(formData);
      // localStorage.setItem('user', JSON.stringify(response.data.data.user));
      // localStorage.setItem('token', JSON.stringify(response.data.data.token));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const ResentOtp = createAsyncThunk(
  "resend",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await resendOtp(formData);
      // localStorage.setItem('user', JSON.stringify(response.data.data.user));
      // localStorage.setItem('token', JSON.stringify(response.data.data.token));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const VerifyOtp = createAsyncThunk(
  "VerifyOtp",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await registerVerify(formData);
      // localStorage.setItem('user', JSON.stringify(response.data.data.user));
      // localStorage.setItem('token', JSON.stringify(response.data.token));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const Loginn = createAsyncThunk(
  "login",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await login(formData);
      // localStorage.setItem('user', JSON.stringify(response.data.data.user));
      // localStorage.setItem('token', JSON.stringify(response.data.data.token));
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response || {
          status: 0,
          data: {
            message:
              "Cannot connect to the Protalz API. Please try again.",
          },
        }
      );
    }
  }
);


export const GoogleLogin = createAsyncThunk(
  "googleLogin",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await googleLogin(formData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const GoogleCompleteRegistration = createAsyncThunk(
  "googleCompleteRegistration",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await googleCompleteRegistration(formData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const SwitchAccount = createAsyncThunk(
  "switchAccount",
  async ({ formData, token }, { rejectWithValue }) => {
    try {
      const response = await switchAccount(formData, token);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const Forgetpwd = createAsyncThunk(
  "Forgetpassword",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await forgetpwd(formData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const SaveIpRecord = createAsyncThunk(
  "save ip address",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await save_ip(formData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

function safeParse(item) {
  // localStorage.removeItem('userData');
  // localStorage.removeItem('token');

  try {
    // console.log("show item from auth ----->",JSON.parse(item));

    return JSON.parse(item);
  } catch (e) {
    console.warn("Invalid JSON in localStorage:", item);
    return null;
  }
}

const authSlice = createSlice({
  name: "auth",
  initialState: {
    error: null,
    success: false,
    auth: localStorage.getItem("user")
      ? safeParse(localStorage.getItem("user"))
      : null,
    token: localStorage.getItem("token")
      ? safeParse(localStorage.getItem("token"))
      : null,
    logout: false,
    dataaa: safeParse(localStorage.getItem("userData")) || {},
    googlePending: safeParse(sessionStorage.getItem("googlePending")) || null,
  },
  reducers: {
    clearStatus: (state) => {
      state.success = false;
      state.error = null;
    },
    setUser: (state, action) => {
      state.auth = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem("token", JSON.stringify(action.payload));
    },
    clearUser: (state) => {
      state.auth = null;
      state.success = false;
      localStorage.removeItem("user");
      state.logout = true;
    },
    clearToken: (state) => {
      state.token = null;
      state.success = false;
      localStorage.removeItem("token");
      state.logout = true;
    },

    setlogout: (state) => {
      state.logout = false;
    },

    clearDattttt: (state) => {
      state.dataaa = {};
      localStorage.removeItem("userData");
    },
    clearGooglePending: (state) => {
      state.googlePending = null;
      sessionStorage.removeItem("googlePending");
    },
    setUserDtaa: (state, action) => {
      state.dataaa = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(RegisterUser.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(RegisterUser.fulfilled, (state, action) => {
        state.success = action.payload;
        state.error = null;
        state.data = action.payload.data.data;
        // state.dataaa = action.payload.data.data.user;
        // state.auth = action.payload.data.data.user;
        // state.token = action.payload.data.data.token;
      })
      .addCase(RegisterUser.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      })
      .addCase(ResentOtp.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(ResentOtp.fulfilled, (state, action) => {
        state.success = action.payload;
        state.error = null;
        state.dataaa = action.payload.data.data.user;
        localStorage.setItem(
          "userData",
          JSON.stringify(action.payload.data.data.user)
        );
        // state.auth = action.payload.data.data.user;
        // state.token = action.payload.data.data.token;
      })
      .addCase(ResentOtp.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      })
      .addCase(VerifyOtp.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(VerifyOtp.fulfilled, (state, action) => {
        state.success = action.payload;
        state.error = null;
        state.dataaa = {};
        state.auth = action.payload.data.data.user;
        state.token = action.payload.data.token;

        localStorage.setItem(
          "user",
          JSON.stringify(action.payload.data.data.user)
        );
        localStorage.setItem(
          "token",
          JSON.stringify(action.payload.data.data.token)
        );
      })
      .addCase(VerifyOtp.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      })
      .addCase(Loginn.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(Loginn.fulfilled, (state, action) => {
        state.success = action.payload;
        state.error = null;
        state.auth = action.payload.data.data.user;
        state.token = action.payload.data.data.token;
        localStorage.setItem(
          "user",
          JSON.stringify(action.payload.data.data.user)
        );
        localStorage.setItem(
          "token",
          JSON.stringify(action.payload.data.data.token)
        );
      })
      .addCase(Loginn.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      })
      .addCase(GoogleLogin.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(GoogleLogin.fulfilled, (state, action) => {
        state.success = action.payload;
        state.error = null;

        if (action.payload?.data?.data?.requires_registration) {
          const googlePendingData = {
            ...action.payload.data.data,
            id_token: action.meta?.arg?.get
              ? action.meta.arg.get("id_token")
              : null,
          };
          state.googlePending = googlePendingData;
          sessionStorage.setItem(
            "googlePending",
            JSON.stringify(googlePendingData)
          );
          return;
        }

        state.googlePending = null;
        sessionStorage.removeItem("googlePending");
        state.auth = action.payload.data.data.user;
        state.token = action.payload.data.data.token;
        localStorage.setItem(
          "user",
          JSON.stringify(action.payload.data.data.user)
        );
        localStorage.setItem(
          "token",
          JSON.stringify(action.payload.data.data.token)
        );
      })
      .addCase(GoogleLogin.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      })
      .addCase(GoogleCompleteRegistration.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(GoogleCompleteRegistration.fulfilled, (state, action) => {
        state.success = action.payload;
        state.error = null;
        state.googlePending = null;
        sessionStorage.removeItem("googlePending");
        state.auth = action.payload.data.data.user;
        state.token = action.payload.data.data.token;
        localStorage.setItem(
          "user",
          JSON.stringify(action.payload.data.data.user)
        );
        localStorage.setItem(
          "token",
          JSON.stringify(action.payload.data.data.token)
        );
      })
      .addCase(GoogleCompleteRegistration.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      })
      .addCase(SwitchAccount.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(SwitchAccount.fulfilled, (state, action) => {
        state.success = action.payload;
        state.error = null;
        state.auth = action.payload.data.data;
        localStorage.setItem("user", JSON.stringify(action.payload.data.data));
      })
      .addCase(SwitchAccount.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      })
      .addCase(Forgetpwd.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(Forgetpwd.fulfilled, (state, action) => {
        state.success = action.payload;
        state.error = null;
      })
      .addCase(Forgetpwd.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      })
      .addCase(SaveIpRecord.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(SaveIpRecord.fulfilled, (state, action) => {
        state.success = action.payload;
        state.error = null;
      })
      .addCase(SaveIpRecord.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      });
  },
});
export const {
  setUser,
  setToken,
  clearStatus,
  clearUser,
  clearToken,
  setlogout,
  clearDattttt,
  clearGooglePending,
  setUserDtaa,
} = authSlice.actions;
export default authSlice.reducer;
